export default __webpack_public_path__ + "static/media/end-hands.7c88dfbf.png";